import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteDivision = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (divisionId: string) =>
      await request(`${sport}/o/${organizationId}/divisions/${divisionId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["divisions", sport, organizationId] });
    },
  });
};
